module.exports = __webpack_public_path__ + "img/2.431cafb3.png";